import type { DynamicClient } from '@dynamic-labs-sdk/client';
import { getNetworkProviderBuilderRegistry } from '@dynamic-labs-sdk/client/core';

import { createSolanaNetworkProvider } from '../utils/createSolanaNetworkProvider';

export const registerSolanaNetworkProviderBuilder = (
  client: DynamicClient
): void => {
  const networkProviderBuilderRegistry =
    getNetworkProviderBuilderRegistry(client);

  /**
   * If the Solana network provider builder is already registered, return.
   */
  if (networkProviderBuilderRegistry.get().get('SOL')) {
    return;
  }

  networkProviderBuilderRegistry.register({
    builder: createSolanaNetworkProvider,
    chain: 'SOL',
  });
};
